import { IoMdRadioButtonOff, IoMdRadioButtonOn } from "react-icons/io"
import PhoneInput from "react-phone-input-2"

export default function MentorDetailsApplication({ setApplicationState, applicationPiece }) {
  /**
   * mentor: {
    personalInformation: {
      contact: '',
      country: '',
      linkedInURL: '',
    },
    qualifications: {
      educationalQualification: {
        title: "",
        supportingDocument: null
      },
      currentProfessionalRole: {
        title: '',
        resume: null
      },
      workExperience: 0, // in months
      previouslyWorkedWithLMS: '',
    }
  }
   */
  return (
    <>
      <h5>Personal Information</h5>
      <p>Tell us more about yourself</p>
      <div className="intended-learners-wr mentor-deets">
      <input onChange={(e)=>{setApplicationState(prev=>({...prev, mentor: {...prev.mentor, personalInformation: {...prev.mentor.personalInformation, name: e.target.value}}}))}} value={applicationPiece.personalInformation.name} placeholder="Full Name" type="text" maxLength={80} />

      <select onChange={(e)=>{setApplicationState(prev=>({...prev, mentor: {...prev.mentor, personalInformation: {...prev.mentor.personalInformation, gender: e.target.value}}}))}} value={applicationPiece.personalInformation.gender}>
        <option value={""}>Choose your gender</option>
        <option value={"Male"}>Male</option>
        <option value={"Female"}>Female</option>
        <option value={"Other"}>Other</option>
      </select>

      <input onChange={(e)=>{setApplicationState(prev=>({...prev, mentor: {...prev.mentor, personalInformation: {...prev.mentor.personalInformation, email: e.target.value}}}))}} value={applicationPiece.personalInformation.email} placeholder="Enter your email" type="text" maxLength={80} />
      <PhoneInput
        country={'us'}
        value={applicationPiece.personalInformation.contact}
        onChange={(phone, country) => setApplicationState(prev=>({...prev, mentor: {...prev.mentor, personalInformation: {...prev.mentor.personalInformation, contact: phone, country}}}))}
      />
      </div>
      <h5>Add your LinkedIn URL</h5>
      <p>This makes you more credible to the students</p>
      <div className="intended-learners-wr">
        <input onChange={(e)=>{setApplicationState(prev=>({...prev, mentor: {...prev.mentor, personalInformation: {...prev.mentor.personalInformation, linkedInURL: e.target.value}}}))}} value={applicationPiece.personalInformation.linkedInURL}  placeholder="Example: https://linkedin.com/..." type="text" />
      </div>
    </>
  )
}